import { ModalRef } from '@ui-components-3/ui/lib/components/Modal'
import { useRef } from 'react'
import CalendarDayIcon from '@ui-components-3/icons/lib/duotone/CalendarDay'
import CalendarCheckIcon from '@ui-components-3/icons/lib/regular/CalendarCheck'
import AddToCalendarModal from '../AddToCalendarModal'
import PendingVisit from 'types/visit/pendingVisit'
import PlusIcon from '@ui-components-3/icons/lib/solid/Plus'
import { useTranslation } from 'react-i18next'

type AddToCalendarTagProps = {
  pendingVisit: PendingVisit
  getCalendarInfo: () => Promise<void>
  variant?: 'default' | 'modal'
}

const AddToCalendarTag = ({ pendingVisit, getCalendarInfo, variant = 'default' }: AddToCalendarTagProps) => {
  const { t } = useTranslation()
  const modalRef = useRef<ModalRef>(null)

  const toggleModal = (action: 'open' | 'close') => {
    modalRef.current?.[action]()
  }

  const isModalVariant = variant === 'modal'

  return (
    <div className={isModalVariant ? 'flex justify-end' : ''}>
      <button
        className={`flex ${
          isModalVariant ? 'h-[40px]' : 'h-[56px] w-full'
        } items-center justify-between rounded-xl bg-white
        px-4`}
        onClick={() => toggleModal('open')}
        type="button"
      >
        <div className="flex items-center">
          {isModalVariant ? (
            <CalendarCheckIcon className="text-primary-600 h-6 w-6" aria-hidden="true" />
          ) : (
            <CalendarDayIcon className="text-primary-600 h-6 w-6" aria-hidden="true" />
          )}
          <p
            className={`typography-body ${isModalVariant ? 'text-primary-600' : 'text-primary-700'} ml-4 font-semibold`}
          >
            {t('visitCard.addCalendar')}
          </p>
        </div>
        {!isModalVariant && <PlusIcon className="text-primary-700 h-6 w-6" aria-hidden="true" />}
      </button>
      <AddToCalendarModal
        closeModal={() => toggleModal('close')}
        ref={modalRef}
        pendingVisit={pendingVisit}
        getCalendarInfo={getCalendarInfo}
      />
    </div>
  )
}

export default AddToCalendarTag
